import {Button, Layout, Modal, Space, Table} from "antd";
import styled from "styled-components";
import {LayoutHeader} from "./Administrator";
import {useMemo} from "react";
import {useSelector} from "react-redux";
import {currentUser} from "../../../../features/user/userSlice";

const InviteWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .limit {
    font-weight: 600;
    color: #00eec2;
  }
`

const Desc = styled.div`
  flex: 1;
  @media (max-width: 768px) {
    font-size: 0;
  }
`

const LayoutContent = styled(Layout.Content)`
  background: #0e0e0e;
  padding-bottom: 40px;
`

const CustomTable = styled(Table)`
  th.ant-table-cell {
    background-color: #0e0e0e;
    color: #4b555e;
    border-bottom: none;
  }
  .ant-table-cell {
    background-color: #0e0e0e;
    border-color: rgba(255, 255, 255, 0.05);
    height: 66px;
    min-width: 70px;
    white-space: nowrap;
    text-overflow: ellipsis;
    z-index: 0;
    .ant-table-filter-column {
      justify-content: flex-start;
      .ant-table-column-title {
        flex: none;
      }
    }
  }
`

export const CoAdministrator = ({list, limit, add, del, reInvite}) => {
    const _USER = useSelector(currentUser);

    const isCoAdmin = useMemo(() => {
        return _USER.user.is_primary === 0
    }, [_USER])

    const administratorColumns = [{
        title: '#',
        key: 'id',
        width: 50,
        render: (_, record) => ( list.indexOf(record) + 1 )
    }, {
        title: 'Name',
        dataIndex: 'username',
        key: 'username',
        width: '500px',
        // align: 'center',
        render: (_, row) => row.user?.name
    }, {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        width: '500px',
        // align: 'center',
        render: (_, row) => row.user?.email
    }, {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        filters: [{
            text: 'Pending',
            value: 0,
        }, {
            text: 'Joined',
            value: 1,
        }, {
            text: 'Expired',
            value: 2,
        }],
        onFilter: (value, record) => record.status === value,
        width: '160px',
        // align: 'center',
        render: (_, row) => {
            switch (row.status) {
                case 0:
                    return <span style={{color: '#FFA31A'}}>Pending</span>
                case 1:
                    return <span style={{color: '#00EEC2'}}>Joined</span>
                case 2:
                    return <span style={{color: '#CD1D2E'}}>Expired</span>
                default:
                    return ''
            }
        }
    }, {
        title: 'Actions',
        width: '200px',
        // align: 'center',
        key: 'Actions',
        hidden: isCoAdmin,
        render: (_, row) => (
            <>
                {row.status === 1 ? (
                    <Button danger onClick={() => del(row)}>Remove</Button>
                ) : null}
                {row.status === 2 ? (
                    <Button type='primary' onClick={() => reInvite(row)}>Reinvite</Button>
                ) : null}
            </>
        )
    }].filter(it => !it.hidden)

    return (
        <>
            <Layout>
                <LayoutHeader>Co-Administrator</LayoutHeader>
                <LayoutContent>
                    <InviteWrapper>
                        <Desc>You can associate multiple co-administrators, and they will all receive email notifications when new reports are submitted</Desc>
                        {
                            !isCoAdmin ? (
                                <Space size={20}>
                                    <span>
                                        You can invite <span className='limit'>{limit}</span> more
                                    </span>
                                    {limit ? <Button type='primary' onClick={() => add()}>Invite</Button> : null}
                                </Space>
                            ) : null
                        }
                    </InviteWrapper>
                    <CustomTable columns={administratorColumns} scroll={{ x: true }} dataSource={list} pagination={false} />
                </LayoutContent>
            </Layout>
        </>
    )
}
